module.exports = "<div>\n  <h2><span class=\"fa fa-spin fa-spinner\"></span></h2>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/common/loading/loading.component.html
// module id = ../../../../../src/app/common/loading/loading.component.html
// module chunks = 1